export default "__VITE_ASSET__Ccgvi8QC__"